<template>
  <CBox>
    <CBox class="firstBox" mt="2vw" textAlign="center">
      <CHeading
        class="firstText"
        color="#393E46"
        font-family="Ubuntu"
        fontWeight="300"
        fontSize="2vw"
      >
        Hi, I'm Kishan!
      </CHeading>
    </CBox>
    <CBox
      class="secondBox"
      w="55vw"
      ml="auto"
      mr="auto"
      mt="3vw"
      textAlign="center"
    >
      <CHeading
        class="secondText"
        fontSize="4.5vw"
        fontFamily="Noto Sans"
        overflowWrap="break-word"
      >
        {{ mainHeader }}
      </CHeading>
    </CBox>
    <CBox
      w="35vw"
      ml="auto"
      mr="auto"
      mt="4vw"
      color="#393E46"
      fontSize="1.5vw"
      class="thirdBox"
      textAlign="center"
      fontFamily="Roboto"
      overflowWrap="break-word"
    >
      {{ subHeader }}
    </CBox>
    <CBox
      class="projectPhoto"
      pos="absolute"
      left="12vw"
      top="18vw"
      transform="rotate(-7deg)"
    >
      <CImage :src="getProject" opacity="0.2" size="15vw" />
    </CBox>
    <CBox class="buildPhoto" pos="absolute" right="10vw" top="45vw">
      <CImage :src="getBuild" opacity="0.4" size="18vw" />
    </CBox>
  </CBox>
</template>

<script>
import { CBox, CImage, CHeading } from "@chakra-ui/vue";
import Project from "../assets/img/Project.png";
import Build from "../assets/img/Build.png";

export default {
  name: "Writing",
  components: {
    CBox,
    CImage,
    CHeading,
  },
  computed: {
    getProject() {
      return Project;
    },
    getBuild() {
      return Build;
    },
  },
  data() {
    return {
      mainHeader: `Building digital products, brands and experience.`,
      subHeader: `Engineer By Profession, Cinephile By Person 💜 Interested in Start-ups, Philosophy and Psychology.`,
    };
  },
};
</script>

<style>
@media screen and (max-width: 480px) {
  .firstBox {
    margin-top: 7vw;
  }
  .firstText {
    font-size: 3vw;
  }
  .secondBox {
    margin-top: 5vw;
  }
  .secondText {
    font-size: 5vw;
  }
  .thirdBox {
    margin-top: 7vw;
    font-size: 2.25vw;
    width: 50vw;
  }
  .projectPhoto {
    left: 15vw;
    top: 25vh;
  }
  .buildPhoto {
    top: 56vh;
    right: 5vw;
  }
}

@font-face {
  font-family: "Ubuntu";
  src: local("Ubuntu"),
    url(../assets/fonts/Ubuntu-Regular.ttf) format("truetype");
}

@font-face {
  font-family: "Noto Sans";
  src: local("Noto Sans"),
    url(../assets/fonts/NotoSans-Bold.ttf) format("truetype");
}

@font-face {
  font-family: "Roboto";
  src: local("Roboto"),
    url(../assets/fonts/Roboto-Medium.ttf) format("truetype");
}
</style>
